export enum DeltaMatrixUAMethods {
  // Initialize the SDK, fetches the config file and loads the script plus authorization
  init = 'init',
  // Mount the SDK, renders the interface in the container element using window.uaMount
  mount = 'mount',
  // If any of the UA settings are changed, call this method to update
  update = 'update',
  // Method to update pageId or pageInputs
  goToPage = 'goToPage',
  // Method to set the theme of the application
  setTheme = 'setTheme',
  // Copilot chat method - open chat
  show = 'show',
  // Copilot chat method - close chat
  hide = 'hide',
  // Show the application mounted in the container element
  showCopilotTrigger = 'showCopilotTrigger',
  // Hide the application mounted in the container element
  hideCopilotTrigger = 'hideCopilotTrigger',
  // Add a message part to the application
  addCopilotResponse = 'addCopilotResponse',
  // Remove a message part from the application
  removeCopilotResponse = 'removeCopilotResponse',
  // Preload copilotResponse
  preloadCopilotResponse = 'preloadCopilotResponse',
}
